// fbConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// const firebaseConfig = {
//   apiKey: "AIzaSyClkZDuOsRySGPCgC5sLx9oflisx4WfWHI",
//   authDomain: "deroyalecashflow.firebaseapp.com",
//   projectId: "deroyalecashflow",
//   storageBucket: "deroyalecashflow.firebasestorage.app",
//   messagingSenderId: "563692809805",
//   appId: "1:563692809805:web:37b3a76fd98e36bcacf604"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCCgx_RI-xpgavDxvLt1iAzzaKIF73tvvY",
  authDomain: "deroyalelodgix.firebaseapp.com",
  projectId: "deroyalelodgix",
  storageBucket: "deroyalelodgix.firebasestorage.app",
  messagingSenderId: "113884682484",
  appId: "1:113884682484:web:1763f28e1f391571dde6a1"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Get Firestore, Auth, and Storage instances
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const storage = getStorage(firebaseApp);

auth.settings.appVerificationDisabledForTesting = true;

// ✅ Export everything you need
export { db, auth, storage, firebaseConfig };
